import { Icon, Typography } from '@/components/common';
import Icons from '@/const/icons';
import AppRoutes from '@/const/routes';
import Link from 'next/link';
import React from 'react';

export const ReviewBanner = () => {
	return (
		<div className="bg-[#FF004314] px-4 py-2 mb-6 flex items-center gap-3 justify-center">
			<Icon src={Icons.flag} className="!w-6 !h-6 text-main-red" />
			<Typography type="regular-16" className="text-main-red">
				Client flagged for review. Please review Account Details and take
				necessary action.
			</Typography>
			<Link href={AppRoutes.LAWYERAPP_CLIENT_DIRECTORY_CLEANUP_WIZARD}>
				<Typography
					type="semibold-16"
					className="text-purple-150 hover:opacity-60"
				>
					Go to Client Cleanup Wizard
				</Typography>
			</Link>
		</div>
	);
};
